import type { Component } from 'solid-js'
import { Show } from 'solid-js'
import type { EventItem, EventsViewType } from '../../../features/engagement/domain/models/events'
import ValueProgressCell from './custom-cells/ValueProgressCell'
import { KPI, KPIType } from '../../../features/analytics/domain/models/kpi'
import { NumericalDataType } from '../../../shared/models/numerical-data-type'

export interface EventsTableRowProps {
  readonly item: EventItem
  readonly rowNumber: number
  readonly viewType: EventsViewType
}

const EventsTableRow: Component<EventsTableRowProps> = (props) => {
  const buyNowClicksKPI = () =>
    new KPI(
      KPIType.BuyNowClicks,
      props.item.buyNowClicks.current,
      NumericalDataType.Units,
      props.item.buyNowClicks.diff,
      props.item.buyNowClicks.previous
    )

  const presaleCodesKPI = () =>
    new KPI(
      KPIType.PresaleCodes,
      props.item.presaleCodes.current,
      NumericalDataType.Units,
      props.item.presaleCodes.diff,
      props.item.presaleCodes.previous
    )

  const meetAndGreetKPI = () =>
    new KPI(
      KPIType.MeetAndGreet,
      props.item.meetAndGreet.current,
      NumericalDataType.Units,
      props.item.meetAndGreet.diff,
      props.item.meetAndGreet.previous
    )

  const vipKPI = () =>
    new KPI(KPIType.Vip, props.item.vip.current, NumericalDataType.Units, props.item.vip.diff, props.item.vip.previous)

  const rsvpKPI = () =>
    new KPI(
      KPIType.Rsvp,
      props.item.rsvp.current,
      NumericalDataType.Units,
      props.item.rsvp.diff,
      props.item.rsvp.previous
    )

  return (
    <tr class="hover:bg-gray-50">
      <td class="whitespace-nowrap border-r border-gray-200 px-3   py-3.5 text-center text-sm text-gray-700">
        {props.rowNumber}
      </td>
      <td class="px-4 py-4 min-w-[260px]">
        <div class="flex items-center gap-2">
          <span class="text-sm font-medium text-gray-900">
            {props.viewType === 'cities' ? props.item.city : props.item.event || props.item.city}
          </span>
          <Show when={props.viewType === 'cities'}>
            <span class="rounded-full px-2.5 py-1 text-xs text-gray-600 border border-gray-200">
              {props.item.numEvents} {props.item.numEvents === 1 ? 'event' : 'events'}
            </span>
          </Show>
        </div>
      </td>
      <td class="w-[152px]">
        <ValueProgressCell kpi={buyNowClicksKPI()} />
      </td>
      <td class="w-[152px]">
        <ValueProgressCell kpi={presaleCodesKPI()} />
      </td>
      <td class="w-[152px]">
        <ValueProgressCell kpi={meetAndGreetKPI()} />
      </td>
      <td class="w-[152px]">
        <ValueProgressCell kpi={vipKPI()} />
      </td>
      <td class="w-[152px]">
        <ValueProgressCell kpi={rsvpKPI()} />
      </td>
    </tr>
  )
}

export default EventsTableRow
